import { useQuery } from '@tanstack/react-query'
import { useState } from 'react'
import { Link } from 'react-router'
import { api, query } from '../../../api/client'
import type { SupportConversationRow } from '../../../api/support'
import { formatRelative } from '../../../lib/format'
import { Segmented } from '../../Segmented'

/** Admin → Support: every account's conversation, unread first. */
export function SupportPanel() {
	const [status, setStatus] = useState<'open' | 'closed'>('open')
	const [page, setPage] = useState(1)
	const list = useQuery({
		queryKey: ['admin-support', status, page],
		queryFn: () =>
			api.get<{ conversations: SupportConversationRow[]; hasMore: boolean }>(
				`/api/v1/admin/support${query({ status, page })}`,
			),
		refetchInterval: 30_000,
	})
	return (
		<section className="card stack">
			<div>
				<Segmented
					label="Conversations"
					value={status}
					options={[
						{ value: 'open', label: 'Open' },
						{ value: 'closed', label: 'Closed' },
					]}
					onChange={(v) => {
						setStatus(v)
						setPage(1)
					}}
				/>
			</div>
			{list.isError && <p className="error small">{list.error.message}</p>}
			<div className="table-scroll">
				<table>
					<thead>
						<tr>
							<th>Account</th>
							<th>Latest message</th>
							<th className="num">Unread</th>
							<th>Updated</th>
						</tr>
					</thead>
					<tbody>
						{list.data?.conversations.map((c) => (
							<tr key={c.id}>
								<td>
									<Link to={`/admin/support/${c.id}`} className="mono">
										{c.supportId}
									</Link>
								</td>
								<td className="small truncate" style={{ maxWidth: '28rem' }}>
									{c.unread > 0 ? <strong>{c.preview}</strong> : c.preview}
								</td>
								<td className="num">{c.unread || ''}</td>
								<td className="muted small">{formatRelative(c.updatedAt)}</td>
							</tr>
						))}
					</tbody>
				</table>
			</div>
			{list.data && !list.data.conversations.length && <p className="muted">No {status} conversations.</p>}
			<div className="row">
				{page > 1 && (
					<button type="button" onClick={() => setPage(page - 1)}>
						Previous
					</button>
				)}
				{list.data?.hasMore && (
					<button type="button" onClick={() => setPage(page + 1)}>
						More
					</button>
				)}
			</div>
		</section>
	)
}
